import React from "react";
import { Helmet } from "react-helmet-async";

const Title = ({ title, content }) => {
  return (
    <div>
      <Helmet>
        <title>{title} - Rakiyan</title>
        <meta name={title} content={content} />
        <link rel="canonical" href="http://rakiyan.com" />
      </Helmet>
    </div>
  );
};

export default Title;
